const ENABLED = "enabled";

export const CHECKOUT_TEST_MODE_QUERY_PARAM = "checkout_test_mode";
export const CHECKOUT_V2_STORAGE_KEY = "checkoutv2";
export const CHECKOUT_V2_TEST_MODE_STORAGE_KEY = "checkoutv2TestMode";
export const FORCE_CHECKOUT_TEST_MODE_STORAGE_KEY = "forceCheckoutv2TestMode";

type CheckoutTestModeStorage = Pick<
  Storage,
  "getItem" | "setItem" | "removeItem"
>;

const truthyValues = new Set(["1", "true", "enabled", "yes"]);
const falsyValues = new Set(["0", "false", "disabled", "no"]);

export function getCheckoutTestModeOverride(search: string): boolean | null {
  const value = new URLSearchParams(search).get(CHECKOUT_TEST_MODE_QUERY_PARAM);

  if (!value) {
    return null;
  }

  const normalizedValue = value.toLowerCase();
  if (truthyValues.has(normalizedValue)) {
    return true;
  }
  if (falsyValues.has(normalizedValue)) {
    return false;
  }

  return null;
}

export function applyCheckoutTestModeOverride(
  search: string,
  storage: CheckoutTestModeStorage = localStorage
) {
  const override = getCheckoutTestModeOverride(search);

  if (override === true) {
    storage.setItem(FORCE_CHECKOUT_TEST_MODE_STORAGE_KEY, ENABLED);
    storage.setItem(CHECKOUT_V2_STORAGE_KEY, ENABLED);
    storage.setItem(CHECKOUT_V2_TEST_MODE_STORAGE_KEY, ENABLED);
    return;
  }

  if (override === false) {
    storage.removeItem(FORCE_CHECKOUT_TEST_MODE_STORAGE_KEY);
    storage.removeItem(CHECKOUT_V2_TEST_MODE_STORAGE_KEY);
  }
}

export function isCheckoutTestModeForced(
  storage: CheckoutTestModeStorage = localStorage
) {
  return storage.getItem(FORCE_CHECKOUT_TEST_MODE_STORAGE_KEY) === ENABLED;
}

export function isCheckoutV2TestModeEnabled(
  storage: CheckoutTestModeStorage = localStorage
) {
  return storage.getItem(CHECKOUT_V2_TEST_MODE_STORAGE_KEY) === ENABLED;
}

export function shouldUseStripeTestMode(
  search: string,
  storage: CheckoutTestModeStorage = localStorage
) {
  const override = getCheckoutTestModeOverride(search);
  if (override !== null) {
    return override;
  }

  return isCheckoutV2TestModeEnabled(storage);
}

export function keepForcedCheckoutTestModeEnabled(
  storage: CheckoutTestModeStorage = localStorage
) {
  if (!isCheckoutTestModeForced(storage)) {
    return false;
  }

  storage.setItem(CHECKOUT_V2_STORAGE_KEY, ENABLED);
  storage.setItem(CHECKOUT_V2_TEST_MODE_STORAGE_KEY, ENABLED);
  return true;
}
